// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/link/link.component.scss
// module id = 59
// module chunks = 0